import { render, staticRenderFns } from "./Numerex.vue?vue&type=template&id=4b61df6f&scoped=true"
import script from "./Numerex.vue?vue&type=script&lang=js"
export * from "./Numerex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61df6f",
  null
  
)

export default component.exports